'use client';

import { SessionIdleWarning } from '@/shared/components/session/SessionIdleWarning';
import { useFetchMe } from '@/shared/hooks/apis/auth/useFetchMe';
import { previewScope } from '@/shared/libs/previewScope';
import { useAuthStore } from '@/shared/store/authStore';

/**
 * Harmonise profil utilisateur (companyName, rôles) avec `/api/v1/auth/me`
 * lorsqu’une session JWT est présente, et porte la garde d’inactivité.
 *
 * Les deux tiennent ici parce qu’ils lisent la même chose : `sessionIdleTimeoutMinutes` arrive
 * avec le profil. Le lire ailleurs demanderait une seconde requête sur chaque écran, pour une
 * valeur déjà en main.
 */
export function SessionProfileSync() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const accessToken = useAuthStore(s => s.accessToken);

  const { currentUser } = useFetchMe({
    enabled: !!(isAuthenticated && accessToken),
    staleTime: 60_000,
  });

  /*
    Aperçu démo (admin qui regarde l’espace d’un consultant fictif) : le jeton est éphémère et sans
    renouvellement. Entretenir cette session-là échouerait à chaque tentative, et annoncer une
    échéance à quelqu’un qui n’en a pas serait faux.
  */
  if (previewScope.getToken()) return null;

  return <SessionIdleWarning setting={currentUser?.sessionIdleTimeoutMinutes} />;
}
